import VueModal from "../components/ui/VueModal.vue";

export default (function () {
    var my = {};
    var errors = {response: {data: {errors: {}}}};

    my.hasErrors = function() {
        return Object.keys(my.errors.response.data.errors).length > 0;
    }

    my.addError = function (field, error) {
        my.errors.response.data.errors[field] = [error];
    }

    my.resetErrors = function() {
        my.errors = {response: {data: {errors: {}}}};
    }

    my.getErrors = function() {
        return my.errors;
    }

    my.processAndShowError = function (error, modal) {
        var data = my.processError(error);
        my.showError(data.title, data.message, modal);

        return data;
    }

    my.processError = function (error) {
        if (error.response && error.response.data.error) {
            return {
                title: 'Error',
                message: error.response.data.error
            }
        } else if (error.response && error.response.data.errors) {
            let errors = {};
            let msg = '';
            Object.keys(error.response.data.errors).forEach(function (item) {
                errors[item] = error.response.data.errors[item][0];
                msg += error.response.data.errors[item][0] + '<br />';
            });

            return {
                title: 'Errors',
                message: msg,
                errors: errors
            }
        } else if (error.response && error.response.data.message) {
            return {
                title: 'Error',
                message: error.response.data.message
            }
        } else if (error.message) {
            return {
                title: 'Error',
                message: error.message
            }
        } else {
            return {
                title: 'Error',
                message: error
            }
        }
    }

    my.showError = function (title, message, modal) {
        if (modal) {
            modal.show({
                component: VueModal
            }, {
                    title: title,
                    message: message,
                    buttons: [{title: 'Close'}]
            })
        } else {
            alert(title + "\r\n\r\n" + message);
        }
    }

    return my;
}());
